<template>
  <tg-layout :headerHeight="60">
    <template slot="header">
      <el-row type="flex" justify="space-between">
        <portal to="tools" :disabled="!isMobile">
          <tg-search-tool :data="searchData" @on-submit="handleSearch">
            <el-input
              :placeholder="$t('component.form.input.placeholder.member')"
              v-model="searchData.targetName"
              class="tg-input input-search-username"
              size="small"
              clearable
            ></el-input>
            <tg-dropdown
              ref="dropdown"
              :items="dropdowns"
              trigger="click"
              @on-change="handleChangeStatus"
            >
              <template slot="icon">
                <i class="tg-icon tg-icon-selfdefine"></i>
              </template>
            </tg-dropdown>
          </tg-search-tool>
        </portal>
          <div v-if="isShowAllActionBtn" style="display: inline-flex;">
            <tg-switch-btn
              :leftLabel="$t('component.btn.bulk_accept')"
              :leftIcon="['far', 'circle']"
              :rightLabel="$t('component.btn.bulk_reject')"
              rightIcon="times"
              style="background-color: blanchedalmond;margin-right: 10px;"
              @on-click="reviewBulk"
            ></tg-switch-btn>
            <tg-switch-btn
              :leftLabel="$t('component.btn.accept_all')"
              :leftIcon="['far', 'circle']"
              :rightLabel="$t('component.btn.reject_all')"
              rightIcon="times"
              @on-click="reviewAll"
            ></tg-switch-btn>
          </div>
      </el-row>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      @on-loaded="handleLoaded"
    >
      <template slot="userId" slot-scope="scope">
          <el-checkbox
              :key="scope.row.user_id"
              @change="handleCheckBoxChange($event, scope.row.user_id)"
          >
          </el-checkbox>
      </template>

      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name
          :row="scope.row"
          :column="scope.column"
        ></tg-user-full-name>
      </template>
      <template slot="statusText" slot-scope="scope">
        <span>{{ $t("component.dropdown.review." + scope.value) }}</span>
      </template>
      <template slot="action" slot-scope="scope" v-if="isNotSub">
        <el-row
          type="flex"
          justify="space-around"
          v-if="scope.row['showActionBtn']"
        >
          <tg-status-btn
            :status="1"
            @on-click="review(scope.row, 'accept')"
          ></tg-status-btn>
          <tg-status-btn
            :status="0"
            @on-click="review(scope.row, 'reject')"
          ></tg-status-btn>
        </el-row>
      </template>
    </tg-table>
    <tg-member-review-dialog
      :visible.sync="showReviewDialog"
      :item="reviewDialog"
      @on-success="handleReviewSuccess"
    ></tg-member-review-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgStatusBtn from "@/components/button/TgStatusBtn";
import TgMemberReviewDialog from "@/components/dialog/TgMemberReviewDialog";
import TgSwitchBtn from "@/components/button/TgSwitchBtn";
import tip from "@/utils/tip";

import apis from "@/apis";

const api = apis.tg_business.member.review;

export default {
  components: {
    TgLayout,
    TgTable,
    TgSearchTool,
    TgDropdown,
    TgUserFullName,
    TgStatusBtn,
    TgMemberReviewDialog,
    TgSwitchBtn,
  },
  data() {
    return {
      proxy: api.getData,
      columns: [],
      reviewColumns: [],
      reviewedColumns: [],
      showReviewDialog: false,
      searchData: {
        targetName: "",
        status: 0,
      },
      reviewDialog: {},
      status: 0,
      hasData: false,
      showAllActionBtn: false,
    };
  },
  created() {
    api.getColumns().then((response) => {
      this.columns = response.data.reviewColumns;
      this.reviewColumns = response.data.reviewColumns;
      this.reviewedColumns = response.data.reviewedColumns;
      this.$refs.table.init(this.searchData);
    });
  },
  computed: {
    isShowAllActionBtn() {
      return (
        this.showAllActionBtn &&
        this.status == 0 &&
        this.hasData &&
        this.isNotSub
      );
    },
    isNotSub() {
      return !this.$user.isSub;
    },
    dropdowns() {
      return [
        {
          value: 0,
          label: this.$t("component.dropdown.review.undo"),
          active: true,
        },
        {
          value: 1,
          label: this.$t("component.dropdown.review.pass"),
        },
        {
          value: 2,
          label: this.$t("component.dropdown.review.unpass"),
        },
      ];
    },
  },
  methods: {
    review(row, action) {
      let targetUserIds = [];
      targetUserIds.push(row.user_id);

      this.reviewDialog = {
        ...row,
        action: action,
        targetUserIds: targetUserIds
      };
      this.showReviewDialog = true;
    },
    reviewBulk(status) {
      let ElTable = this.$refs.table.$refs.ElTable;
      let selected = ElTable.store.states.selection.map((x) => x.user_id);

      if (selected.length == 0) {
        tip.warning({
          message: this.$t("message.tip.check_box"), 
        });
        return;
      }

      let action = status == true ? "accept" : "reject";
      this.reviewDialog = {
        action: action + "-bulk",
        targetUserIds: selected
      };
      this.showReviewDialog = true;
    },
    reviewAll(status) {
      let action = status == true ? "accept" : "reject";

      this.reviewDialog = {
        action: action + "-all",
      };
      this.showReviewDialog = true;
    },
    handleReviewSuccess(event) {
      let status = event.isAccept ? 1 : 2;

      this.$refs.dropdown.selectItem(status);
      this.handleSearch();
    },
    handleChangeStatus(item) {
      this.searchData.status = item.value;
    },
    handleSearch() {
      this.$refs.table.search(this.searchData);
      this.status = this.searchData.status;
    },
    handleLoaded(response) {
      this.$store.dispatch("app/fetch");
      if(response.retcode == 0){
        this.hasData = response.data.length > 0;
        this.showAllActionBtn = response.showActionBtn;
        this.columns =
          this.status == 0 ? this.reviewColumns : this.reviewedColumns;
      }
    },
    handleCheckBoxChange(val, user_id) {
      console.log(val, user_id)
    },
  },
};
</script>
